import { render, staticRenderFns } from "./index.vue?vue&type=template&id=85d777d4&"
import script from "./zPayActionCard.js?vue&type=script&lang=js&"
export * from "./zPayActionCard.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports